export default __webpack_public_path__ + "static/media/highlight6.51e5998d.jpg";